import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectionCard from './MultiSelectionCard';
import SingleSelectionCard from './SingleSelectionCard';
import Col from 'kepler/lib/components/Col';

const StepsOptions = props => {
  let { steps, handleChange, products } = props;
  let quizSteps = steps.options.map(step => {
    if (steps.multi) {
      return (
        <Col
          className="step-multi-selection"
          key={step.value}
          style={{ width: steps.square ? '50%' : '33%' }}
        >
          <MultiSelectionCard
            step={step}
            handleChange={handleChange}
            isActive={products.includes(step.value)}
          />
        </Col>
      );
    }
    return (
      <Col
        className="step-single-selection"
        key={step.value}
        style={{ width: steps.square ? '50%' : '33%' }}
      >
        <SingleSelectionCard
          step={step}
          handleChange={handleChange}
          isActive={products.includes(step.value)}
        />
      </Col>
    );
  });
  return quizSteps;
};

StepsOptions.propTypes = {
  steps: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
  products: PropTypes.array
};

export default StepsOptions;
